import { render, staticRenderFns } from "./LoanTransactionWizard.vue?vue&type=template&id=183cf986"
import script from "./LoanTransactionWizard.vue?vue&type=script&lang=js"
export * from "./LoanTransactionWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports